import { render, staticRenderFns } from "./mineCoupon.vue?vue&type=template&id=c4e22336&scoped=true"
import script from "./mineCoupon.vue?vue&type=script&lang=js"
export * from "./mineCoupon.vue?vue&type=script&lang=js"
import style0 from "./mineCoupon.vue?vue&type=style&index=0&id=c4e22336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e22336",
  null
  
)

export default component.exports